module.exports = __webpack_public_path__ + "media/images/menu/dark_nebulae-218c2fd50ea2530a610445434095cdfa.jpg";